import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ConfigProvider } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import './index.css'
import App from './App'
import { Provider } from 'react-redux';
import store from './redux/store';
import 'antd/dist/reset.css';

const globalSpinIndicator = <LoadingOutlined spin />;

const brandTheme = {
  token: {
    colorPrimary: '#19C7D6',
    colorInfo: '#10B8D4',
    colorLink: '#19C7D6',
    colorLinkHover: '#10B8D4',
    colorSuccess: '#19C7D6',
    borderRadius: 8,
    borderRadiusLG: 12,
    fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 14,
    colorBgLayout: '#F7F9FC',
    controlHeight: 36,
  },
  components: {
    Button: {
      colorPrimary: '#19C7D6',
      colorPrimaryHover: '#10B8D4',
      colorPrimaryActive: '#0E9FB8',
      algorithm: true as const,
    },
    Menu: {
      itemBg: '#FFFFFF',
      subMenuItemBg: '#FFFFFF',
      itemSelectedBg: '#19C7D6',
      itemHoverBg: '#E6FAFC',
      itemSelectedColor: '#FFFFFF',
      itemHoverColor: '#19C7D6',
      itemColor: '#0F172A',
      iconSize: 16,
    },
    Table: {
      headerBg: '#f8fafb',
      headerColor: '#44475b',
    },
    Tabs: {
      inkBarColor: '#19C7D6',
      itemActiveColor: '#19C7D6',
      itemSelectedColor: '#19C7D6',
      itemHoverColor: '#10B8D4',
    },
    Input: {
      activeBorderColor: '#19C7D6',
      hoverBorderColor: '#19C7D6',
      activeShadow: '0 0 0 2px rgba(25, 199, 214, 0.1)',
      // Prevent the inner <input> inside affix-wrapper from adding its own visible border
      paddingInline: 11,
      paddingBlock: 4,
    },
    Select: {
      optionSelectedBg: 'rgba(25, 199, 214, 0.1)',
      optionActiveBg: 'rgba(25, 199, 214, 0.06)',
    },
    Switch: {
      colorPrimary: '#19C7D6',
      colorPrimaryHover: '#10B8D4',
    },
    Progress: {
      defaultColor: '#19C7D6',
    },
    Steps: {
      colorPrimary: '#19C7D6',
    },
  },
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={brandTheme}
        spin={{ indicator: globalSpinIndicator }}
        getPopupContainer={() => document.body}
      >
        <App />
      </ConfigProvider>
    </Provider>
  </StrictMode>,
)